/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-06-04 12:50:02
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-11-23 17:18:48
 * @FilePath: /unifyxp-v2-store-portal/src/types/common/sider.ts
 */
export enum EnumSider {
  Button = 'Button',
  Text = 'Text',
  Header = 'Header',
  Animation = 'Animation',
  Navigation = 'Navigation',
  ContentHomePage = 'ContentHomePage',
  AllProductsPage = 'AllProductsPage',
  Page404 = 'Page404',
  MaintenancePage = 'MaintenancePage',
  ProductSearchPage = 'ProductSearchPage',
  ContentPage = 'ContentPage',
  TabBar = 'TabBar',
  ShoppingCartPage = 'ShoppingCartPage',
  ContentPromotionPage = 'ContentPromotionPage',
  ContentProfilePage = 'ContentProfilePage',
  AppearancePage = 'AppearancePage',
  Footer = 'Footer',
  MegaMenu = 'MegaMenu',
  ContentCompaignPage = 'ContentCompaignPage',
  PopupWindowPromotion = 'PopupWindowPromotion',
  SalesChannelProductContent = 'SalesChannelProductContent',
  SalesChannelProductLinkProduct = 'LinkProduct',
  Content = 'Content',
  Products = 'Products',
  productCollection = 'productCollection',
  SalesChannelProductAlias = 'SalesChannelProductAlias',
  salesChannelSettings = 'salesChannelSettings',
  CustomerListPage = 'CustomerListPage',
  SalesChannelDiscountsSubscriptionBuy = 'SalesChannelDiscountsSubscriptionBuy',
  SalesChannelDiscountsVoucher = 'SalesChannelDiscountsVoucher',
  SalesChannelDiscountsDirectDiscount = 'SalesChannelDiscountsDirectDiscount',
}

export enum EnumSiderEvent {
  salesChannel = 'salesChannel',
  salesChannelContent = 'salesChannelContent',
  salesChannelProduct = 'salesChannelProduct',
  customers = 'customers',
}
